import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faCircleExclamation } from '@fortawesome/pro-light-svg-icons';
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Grid,
  Box,
  Badge,
} from '@mui/material';
import {
  ACTION_HIDE,
  ACTION_UNHIDE,
  ALERT_KEY_FINANCIAL_AID,
  CRITICAL,
  ALERT_KEY_STUDENT_PROGRESS_NOTIFICATIONS,
} from '../common/constants';
import AlertAction from './AlertAction';
import AlertContact from './AlertContact';
import AlertProhibits from './AlertProhibits';
import AlertDescription from './AlertDescription';
import { cleanUpID } from '../common/utils';
import { PortalTable } from '../common/DataTable/PortalTable';

class Alert extends Component {
  state = {
    isExpand: false,
    isCritical: false,
  };

  componentDidMount() {
    if (this.props.item?.def?.severity === CRITICAL) {
      this.setState({ isCritical: true, isExpand: true });
    } else if (this.props.expand) {
      this.setState({ isExpand: true });
    }
  }

  toggleIsExpand = () => {
    this.setState({ isExpand: !this.state.isExpand });
  };

  render() {
    const isProhibitAvailable = this.props.item.def?.prohibits?.length > 0;
    let finalAddressLine = this.props.item.def?.primaryContactOffice;
    const addressLine1 = this.props.item.def?.primaryAddressLine1;
    if (addressLine1) {
      finalAddressLine = `${finalAddressLine ?? ''}, ${addressLine1}`;
    }
    const addressLine2 = this.props.item.def?.primaryAddressLine2;
    const phoneNumber = this.props.item.def?.primaryPhone;
    const email = this.props.item.def?.primaryContactEmail;
    const isContactsSectionVisible = finalAddressLine || phoneNumber || email;
    const linkTitle = this.props.item.def?.linkTitle;
    const linkUrl = this.props.item.def?.linkUrl;

    return (
      <Accordion
        elevation={0}
        expanded={this.state.isExpand}
        id={this.props.id + '__accordion_' + this.props.index}
        className={
          'myOdu__accordion statusAlert myOdu__border p-2 ' +
          (this.state.isCritical ? 'error' : ' nonCritical')
        }
        sx={{
          width: '100%',
          p: this.state.isCritical ? '1' : 0,
          m: 0,
        }}
      >
        <AccordionSummary
          expandIcon={
            <FontAwesomeIcon
              id={this.props.id + '__icon_chevronDown_' + this.props.index}
              icon={faChevronDown}
              size="lg"
            />
          }
          id={this.props.id + '__accordionSummary_' + this.props.index}
          aria-controls={this.props.id + '__accordionDetails_' + this.props.index}
          sx={{
            m: 0,
            p: '1rem',
            flexDirection: 'row-reverse',
            flexGrow: 1,
          }}
          onClick={this.toggleIsExpand}
        >
          <Stack
            id={this.props.id + '__stackTitleWrapper_' + this.props.index}
            direction="row"
            sx={{ ml: 0.5 }}
          >
            {this.state.isCritical && (
              <FontAwesomeIcon
                id={this.props.id + '__iconChevron_' + this.props.index}
                fixedWidth
                className="myOdu__error"
                icon={faCircleExclamation}
                style={{
                  alignSelf: 'center',
                  marginRight: '.25rem',
                }}
                size="lg"
              />
            )}
            <Typography
              id={this.props.id + '__textTitle_' + this.props.index}
              variant="h6"
              component="h4"
            >
              {this.props.item.title}
            </Typography>
            <Badge
              id={this.props.id + '__badge_' + this.props.index}
              badgeContent={this.props.item.recordsCount}
              className="myOdu__badge secondary"
              sx={{ ml: 1, mr: 2 }}
            />
          </Stack>
        </AccordionSummary>
        <AccordionDetails
          //NOTE: when the AccordionSummary is provided with a aria-control it automatically makes
          // an id for the AccordionDetails with that ID
          // So this LOC is not needed:
          // id={ this.props.id + '__accordionDetails_' + this.props.index }
          sx={{}}
        >
          <Stack
            id={this.props.id + '__stack_' + this.props.index}
            direction={{
              // xs: 'column-reverse', //JMD remove
              lg: 'row',
            }}
            sx={{ m: 0, p: '0 0 1rem 0' }}
            justifyContent="space-between"
          >
            {this.props.alertKey === ALERT_KEY_STUDENT_PROGRESS_NOTIFICATIONS ? (
              <PortalTable
                row={{ subRows: this.props.item.records }}
                subRowColumns={[
                  { field: 'dateTime', headerName: 'Date Submitted', width: '10%' },
                  { field: 'progress', headerName: 'Progress', width: '50%' },
                  { field: 'reason', headerName: 'Reason', width: '30%' },
                ]}
                tableHeight="auto"
                noDataText="No notifications found."
                noDataTextAlign="left"
                className="alertsTable"
                dateTimeFormat="MM/DD/YYYY h:mm A"
              />
            ) : (
              <Box id={this.props.id + '__boxDescription_' + this.props.index}>
                <AlertDescription
                  id={this.props.id + '__AlertDescription_' + this.props.index}
                  description={this.props.item.def?.text}
                  alertKey={this.props.alertKey}
                  index={this.props.index}
                  linkTitle={linkTitle}
                  linkUrl={linkUrl}
                />

                <Grid id={this.props.id + '__gridContainer_' + this.props.index} container>
                  {isProhibitAvailable && (
                    <Grid
                      id={this.props.id + '__grid_' + this.props.index}
                      item
                      xs={12}
                      md={6}
                      sx={{ mt: 1 }}
                    >
                      <AlertProhibits
                        id={this.props.id + '__alertProhibits_' + this.props.index}
                        prohibits={this.props.item.def?.prohibits}
                        alertKey={this.props.alertKey}
                      />
                    </Grid>
                  )}

                  {isContactsSectionVisible && (
                    <Grid
                      id={this.props.id + '__gridContact_' + this.props.index}
                      item
                      xs={12}
                      md={isProhibitAvailable ? 6 : 12}
                      sx={{ mt: 1 }}
                    >
                      <AlertContact
                        id={this.props.id + '__alertContact_' + this.props.index}
                        addressLine1={finalAddressLine}
                        contactUrl={this.props.item.def?.primaryContactUrl}
                        addressLine2={addressLine2}
                        phoneNumber={phoneNumber}
                        email={email}
                        alertKey={this.props.alertKey}
                        index={this.props.index}
                      />
                    </Grid>
                  )}
                </Grid>
              </Box>
            )}
            {this.props.alertKey === ALERT_KEY_FINANCIAL_AID &&
              ((this.props.item.def?.hideable && this.props.action === ACTION_HIDE) ||
                this.props.action === ACTION_UNHIDE) && (
                <Box
                  id={this.props.id + '__box_' + this.props.index}
                  sx={{ minWidth: '7rem', mb: 1, ml: { lg: 1 } }}
                >
                  <AlertAction
                    id={this.props.id + '__alertAction_' + this.props.index}
                    item={this.props.item}
                    action={this.props.action}
                    toggleAlertVisibility={this.props.toggleAlertVisibility}
                    label={
                      this.props.item.def?.hideable && this.props.action === ACTION_HIDE
                        ? 'Hide Alert'
                        : 'Unhide Alert'
                    }
                  />
                </Box>
              )}
          </Stack>
        </AccordionDetails>
      </Accordion>
    );
  }
}

export default Alert;
